import { UILabel } from "@omni/ui/components/Product/Label/label.style";
import { tv } from "tailwind-variants";

export const label = tv({
    extend: UILabel,
    slots: {
        entry: ""
    },
    variants: {
        variant: {
            primary: { entry: "tw:bg-secondary tw:text-white" },
            secondary: { entry: "tw:bg-primary tw:text-white" }
        }
    }
});
